/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/*------------------------------------------------------------------
Add conditional scripts to the ScriptLoader object below
------------------------------------------------------------------*/

function loadScripts() {
  // Add the src and a condition required to load the script
  window.ScriptsLoaded = ScriptLoader({
    './components/global': true,
    './elements/header': document.querySelector('.js-header'),
    './elements/mega-menu': document.querySelector('.js-mega-menu'),
    './elements/mobile-menu': document.querySelector('.js-mobile-menu'),
    './elements/banner': document.querySelector('.js-banner'),
    './elements/search': document.querySelector('.js-search'),
    './elements/buttons': document.querySelector('p .button, input[type="submit"]'),
    './elements/tabbed-navigation': document.querySelector('.js-tabbed-navigation'),
    './elements/inspiration-banner': document.querySelector('.js-inspiration-banner'),
    './elements/locations-map': document.querySelector('.js-locations'),
    './elements/patterned-product-colours': document.querySelector('.js-patterned-product-colours'),
    './pages/documents': document.querySelector('.js-documents'),
    './pages/products-holder': document.querySelector('.js-products-holder'),
    './pages/blog-holder': document.querySelector('.js-blog-holder'),
    './pages/inspiration-holder': document.querySelector('.js-inspiration-holder'),
    './pages/concrete-volume-calculator': document.querySelector('.js-concrete-volume-calculator'),
    './pages/paving-calculator': document.querySelector('.js-paving-calculator'),
    './pages/hot-edge': document.querySelector('.js-hot-edge'),
    './pages/products': document.querySelector('.js-products'),
    './xmlfeed/index': document.querySelector('.xml-feed')
  });
}
;
function loadReactiveScripts() {
  // Add the script's path and the element selector, they will be imported on demand when the element is added to the page
  ReactiveLoader({
    './elements/buttons': 'p .button',
    './components/selectors': 'select',
    './elements/videos': '[data-video]',
    './elements/video-modals': '[data-video-modal]',
    './elements/forms': 'input, textarea, form',
    './elements/form-validation': 'form.userform, .js-form form',
    './elements/buttons': 'p .button, input[type="submit"]',
    './components/equalizer': '[data-equalize], [data-match-height]'
  });
}

// Once the scripts have loaded
window.addEventListener('scripts-loaded', () => {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #f7ebde");
  document.body.classList.add('scripts-loaded');
});

// Initialize the element watchers when the document is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    loadScripts();
    loadReactiveScripts();
  });
} else {
  loadScripts();
  loadReactiveScripts();
}